import React from "react";

const LoadingIndicator = () => {
  return (
    <div className="fixed inset-0 flex flex-col items-center justify-center bg-[#F5F5F5] z-50">
      <div className="relative flex items-center justify-center">
        {/* Outer pulse ring */}
        <div className="absolute w-24 h-24 border-4 border-teal-500 rounded-full animate-ping opacity-20"></div>

        {/* Main spinning ring */}
        <div className="w-16 h-16 border-4 border-teal-100 border-t-teal-500 rounded-full animate-spin"></div>

        {/* Inner static or pulsing dot */}
        <div className="absolute w-4 h-4 bg-teal-500 rounded-full animate-pulse"></div>
      </div>

      <div className="mt-8 flex flex-col items-center gap-2">
        <h2 className="text-xl font-bold text-gray-800 font-sans tracking-tight animate-pulse bg-gradient-to-r from-teal-600 to-teal-400 bg-clip-text text-transparent">
          Memuat Data
        </h2>
        <div className="flex gap-1">
          <div className="w-1.5 h-1.5 bg-teal-400 rounded-full animate-bounce [animation-delay:-0.3s]"></div>
          <div className="w-1.5 h-1.5 bg-teal-500 rounded-full animate-bounce [animation-delay:-0.15s]"></div>
          <div className="w-1.5 h-1.5 bg-teal-600 rounded-full animate-bounce"></div>
        </div>
        <p className="text-sm text-gray-500 font-sans mt-2">
          Mohon tunggu sebentar...
        </p>
      </div>
    </div>
  );
};

export default LoadingIndicator;
